import axios, { AxiosResponse } from 'axios';

import { ERozsahPPN } from 'services/dokumenty/navyseni';

import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';

import { ETypPrevodu } from './uePozadavky';
import { ISouborPolozka } from './ueSoubor';

export interface IPrehledPozadavek {
    mena?: string;
    id?: number;
    typ?: ETypPozadavku;
    isin?: string;
    datum?: string;
    datuhr?: string;
    aktivni?: boolean;
    pocetcp?: number;
    cenacp?: number;
    zaevidovanecp?: number;
    nezaevidovanecp?: number;
    vyporadanecp?: number;
    nevyporadanecp?: number;
    pocetuctu?: number;
    zaevidovaneucty?: number;
    nezaevidovaneucty?: number;
    vyporadaneucty?: number;
    nevyporadaneucty?: number;
    kontrolauctu?: number;
    overeneucty?: number;
    stav?: EStavPozadavku;
    polozky?: ISouborPolozka[];
    sankce?: boolean;
    puvodcdcp?: boolean;
    ppn?: boolean;
    rozsahppn?: ERozsahPPN;
    meznidatum?: string;
    typtransakce?: string;
    dlt?: boolean;
    typprevodu?: ETypPrevodu;
    neuhrazeneucty?: number;
    neuhrazenecp?: number;
    zaevidovano?: boolean;
    pocetcpvn?: string;
}

export interface IPrehled {
    offset: number;
    limit: number;
    count: number;
    order: string;
    pozadavky: IPrehledPozadavek[];
}

export interface IPrehledQuerry {
    typ?: ETypPozadavku;
    isin?: string;
    datum?: string;
    aktivni?: boolean;
    offset?: number;
    limit?: number;
    order?: string;
}

/* Vrátí seznam požadavků (dlaždic) */
const uePrehledApi = (data?: IPrehledQuerry | undefined) => {
    return axios({
        method: 'GET',
        url: '/UE/prehled',
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPrehled>) => resp.data);
};

export default uePrehledApi;
